export default __webpack_public_path__ + "2f12ba98845fa0e5903b890b2915e45e.png";